/* Belilan - labelled model cards for the PDP variant picker.
   Data: snippets/bl-model.liquid (real name + price per option value, optional groups).
   Turns Minimog's unlabelled image swatch row into named cards, and lists grouped
   values (air purifiers, then their compatible replacement filters) under headings.
   Native radios are kept and never rewritten, so the theme still owns selection,
   price, media and add-to-cart. Re-applies after the theme re-renders the picker. */
(function () {
  var dataEl = document.querySelector('script[data-bl-model]');
  if (!dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var ITEMS = DATA.items || [];
  var LABELS = DATA.labels || [];
  if (ITEMS.length < 2) return;

  var section = dataEl.closest('.m-main-product') || document.querySelector('.m-main-product');
  if (!section) return;

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Card mode is for families: listings whose values carry a different real product
     name than the option value ("Bright White" is actually an LV-H132). Plain
     colourways keep the theme's compact swatch row. */
  var isFamily = LABELS.length > 1 || ITEMS.some(function (it) {
    return it.n && norm(it.n) !== norm(it.v);
  });
  if (!isFamily) return;

  var BY_VALUE = {};
  ITEMS.forEach(function (it, i) {
    it._i = i;
    BY_VALUE[norm(it.v)] = it;
  });

  var observer = null;

  function contentEl() {
    var picker = section.querySelector('variant-picker');
    if (!picker) return null;
    var inner = picker.querySelector('.m-product-option__inner[data-option-name]');
    if (!inner) return null;
    var content = inner.querySelector('.m-product-option--content');
    if (!content) return null;
    if (!content.querySelector('.m-product-option--node[data-option-type="image"]')) return null;
    return content;
  }

  function sharpen(label, item) {
    var bg = label.style.backgroundImage;
    if (bg && bg.indexOf('url(') === 0) {
      if (/width=\d+/.test(bg)) label.style.backgroundImage = bg.replace(/width=\d+/, 'width=200');
      return;
    }
    if (item && item.img) {
      label.style.backgroundImage = 'url(' + item.img + ')';
      label.classList.add('has-bg-img');
    }
  }

  /* The store's money format is the currency converter's wrapper
     (<span class=money>${{amount}}</span>), so `variant.price | money` hands us
     HTML, not text. Written with textContent it printed the tag literally on
     every card. Render it as markup - the same trust as any theme's
     {{ price | money }} - so the converter can find and convert these prices too.
     The data-bl-money guard stops us overwriting a price the converter has
     already rewritten, which would otherwise flip back and forth forever. */
  function setPrice(el, money) {
    if (!el) return;
    var m = money || '';
    if (el.getAttribute('data-bl-money') === m) return;
    el.setAttribute('data-bl-money', m);
    if (m) el.innerHTML = m;
    else el.textContent = '';
  }

  function decorate() {
    var content = contentEl();
    if (!content) return;

    var nodes = content.querySelectorAll('.m-product-option--node[data-option-type="image"]');
    if (!nodes.length) return;

    Array.prototype.forEach.call(content.querySelectorAll('.bl-mp__group'), function (g) {
      g.parentNode.removeChild(g);
    });

    var seenGroup = {};
    Array.prototype.forEach.call(nodes, function (node) {
      var item = BY_VALUE[norm(node.getAttribute('data-value'))];
      var input = node.querySelector('.m-product-option__input');
      var label = node.querySelector('.m-product-option--node__label');
      if (!input || !label) return;

      sharpen(label, item);

      var g = item && LABELS.length > 1 ? (item.g || 0) : 0;
      node.style.order = String(g * 1000 + (item ? item._i : 0) + 1);

      if (LABELS.length > 1 && !seenGroup[g] && LABELS[g]) {
        seenGroup[g] = true;
        var head = document.createElement('div');
        head.className = 'bl-mp__group';
        head.style.order = String(g * 1000);
        head.appendChild(document.createTextNode(LABELS[g]));
        content.appendChild(head);
      }

      var cap = node.querySelector('.bl-mp__cap');
      if (!cap) {
        cap = document.createElement('label');
        cap.className = 'bl-mp__cap';
        cap.appendChild(document.createElement('span')).className = 'bl-mp__name';
        cap.appendChild(document.createElement('span')).className = 'bl-mp__price';
        node.appendChild(cap);
      }
      if (input.id) cap.setAttribute('for', input.id);
      cap.querySelector('.bl-mp__name').textContent = item && item.n ? item.n : (node.getAttribute('data-value') || '');
      setPrice(cap.querySelector('.bl-mp__price'), item && item.p);
    });

    content.classList.add('bl-mp');
    section.setAttribute('data-bl-mp', '1');
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(); }, 40);
  }

  /* Minimog REPLACES the whole <variant-picker> element after a variant change, so
     an observer bound to the picker itself goes deaf the first time it fires. Watch
     the section instead, and take the theme's own event as the precise signal. */
  function run() {
    if (observer) observer.disconnect();
    try { decorate(); } catch (e) { /* never break the picker */ }
    /* Our prices are new nodes the converter has never seen. Re-convert while the
       observer is off so its own DOM writes cannot bounce back into decorate(). */
    try {
      if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
        window.bucksCC.reConvert();
      }
    } catch (e) { /* the converter is the app's problem, never ours */ }
    if (observer) {
      observer.takeRecords();
      observer.observe(section, { childList: true, subtree: true });
    }
  }

  observer = new MutationObserver(schedule);
  document.addEventListener('variant:changed', schedule);
  run();
})();
